import { render, staticRenderFns } from "./BillInfo.vue?vue&type=template&id=01e60e60"
import script from "./BillInfo.vue?vue&type=script&lang=js"
export * from "./BillInfo.vue?vue&type=script&lang=js"
import style0 from "./BillInfo.vue?vue&type=style&index=0&id=01e60e60&prod&lang=css"
import style1 from "./BillInfo.vue?vue&type=style&index=1&id=01e60e60&prod&lang=scss"
import style2 from "./BillInfo.vue?vue&type=style&index=2&id=01e60e60&prod&lang=scss"
import style3 from "./BillInfo.vue?vue&type=style&index=3&id=01e60e60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports